import apiClient from './apiClient';

const URL = (process.env.REACT_APP_API_URL || 'http://localhost:4000/api') + '/tarjetas';

/**
 * Obtiene el listado de tarjetas, opcionalmente filtradas por rol_cod.
 * @param {Object} filter { rol_cod?: string }
 */
export const getTarjetas = async (filter = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (filter.rol_cod) {
      queryParams.append('rol_cod', filter.rol_cod);
    }
    const queryString = queryParams.toString();
    const endpoint = queryString ? `${URL}?${queryString}` : URL;

    const response = await apiClient(endpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    if (response.status !== 200) {
      throw new Error(data.message || 'Error al obtener las tarjetas');
    }
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Obtiene una tarjeta por su ID.
 * @param {number|string} id
 */
export const getTarjetaById = async (id) => {
  try {
    const response = await apiClient(`${URL}/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    if (response.status !== 200) {
      throw new Error(data.message || `Error al obtener la tarjeta ${id}`);
    }
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Crea una nueva tarjeta.
 * @param {Object} tarjetaData { nombre: string, rol_cod: string }
 */
export const postTarjeta = async (tarjetaData) => {
  try {
    const response = await apiClient(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(tarjetaData),
    });
    const data = await response.json();
    if (response.status !== 201) {
      throw new Error(data.message || 'Error al crear la tarjeta');
    }
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Actualiza una tarjeta existente por su ID.
 * @param {number|string} id
 * @param {Object} tarjetaData { nombre?: string, rol_cod?: string }
 */
export const putTarjeta = async (id, tarjetaData) => {
  try {
    const response = await apiClient(`${URL}/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(tarjetaData),
    });
    const data = await response.json();
    if (response.status !== 200) {
      throw new Error(data.message || `Error al actualizar la tarjeta ${id}`);
    }
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Elimina una tarjeta por su ID (borrado en cascada de sus enlaces).
 * @param {number|string} id
 */
export const deleteTarjeta = async (id) => {
  try {
    const response = await apiClient(`${URL}/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    if (response.status !== 200) {
      throw new Error(data.message || `Error al eliminar la tarjeta ${id}`);
    }
    return data;
  } catch (error) {
    throw error;
  }
};
